module.exports = __webpack_public_path__ + "img/istp.0b690b7a.png";